import axios from 'axios';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';

const invoiceStatsApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
invoiceStatsApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log('Invoice Stats API - Token found:', !!token);
    if (token) {
      config.headers.Authorization = `Token ${token}`;
      console.log('Invoice Stats API - Authorization header set:', config.headers.Authorization.substring(0, 20) + '...');
    }
    console.log('Invoice Stats API - Request URL:', config.baseURL + config.url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
invoiceStatsApi.interceptors.response.use(
  (response) => {
    console.log('Invoice Stats API - Success response:', response.status);
    return response;
  },
  (error) => {
    console.error('Invoice Stats API - Error response:', error.response?.status, error.response?.data);
    return Promise.reject(error);
  }
);

export const getInvoiceProcessingStats = async (params = {}) => {
  try {
    console.log('Fetching invoice processing stats with params:', params);
    
    // Try using relative URL first (like other APIs)
    const response = await axios.get('/api/v1/invoice-processing-stats/', {
      params: {
        filter: params.filter || 'weekly',
        start_date: params.start_date,
        end_date: params.end_date,
        department_codes: params.department_codes,
        status: params.status,
        ...params
      },
      headers: { 
        'Authorization': `Token ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('Invoice stats response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching invoice processing stats:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    
    // If relative URL fails, fallback to full URL
    if (error.response?.status === 404) {
      console.log('Trying with axios instance...');
      try {
        const fallbackResponse = await invoiceStatsApi.get('/api/v1/invoice-processing-stats/', {
          params: {
            filter: params.filter || 'weekly',
            start_date: params.start_date,
            end_date: params.end_date,
            department_codes: params.department_codes,
            status: params.status,
            ...params
          }
        });
        return fallbackResponse.data;
      } catch (fallbackError) {
        console.error('Fallback also failed:', fallbackError);
        throw fallbackError;
      }
    }
    
    throw error;
  }
};

export default {
  getInvoiceProcessingStats
};
